"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = exports.ParseError = void 0;
exports.tokenize = tokenize;
exports.parse = parse;
const scanner_1 = require("./scanner");
const expression_1 = require("./expression");
const token_type_1 = require("./token_type");
function tokenize(source) {
    const scanner = new scanner_1.Scanner(source);
    return scanner.scanTokens();
}
function parse(source) {
    const tokens = tokenize(source);
    const parser = new Parser(tokens);
    const statements = parser.parse();
    return statements;
}
class ParseError extends Error {
    constructor(message, expectedType, token) {
        super(message);
        this.expectedType = expectedType;
        this.token = token;
        this.name = token.lexeme;
        this.line = token.line;
        this.start = token.start;
        this.end = token.end;
    }
}
exports.ParseError = ParseError;
class Parser {
    constructor(tokens) {
        this.tokens = tokens;
        this.current = 0;
        this.tokens = tokens;
    }
    parse() {
        const expressions = [];
        while (!this.isAtEnd()) {
            if (this.check(token_type_1.TokenType.Whitespace)) {
                this.advance();
            }
            else {
                expressions.push(this.expression());
            }
        }
        return expressions;
    }
    expression() {
        while (this.check(token_type_1.TokenType.Whitespace)) {
            this.advance();
        }
        if (this.check(token_type_1.TokenType.Number)) {
            const token = this.advance();
            return new expression_1.Literal(token.literal, token);
        }
        if (this.check(token_type_1.TokenType.String)) {
            return this.stringLiteral();
        }
        if (this.check(token_type_1.TokenType.True)) {
            return new expression_1.Literal(true, this.advance());
        }
        if (this.check(token_type_1.TokenType.False)) {
            return new expression_1.Literal(false, this.advance());
        }
        if (this.check(token_type_1.TokenType.Identifier) && this.checkNext(token_type_1.TokenType.LeftParen, token_type_1.TokenType.EOF)) {
            return this.function();
        }
        if (this.check(token_type_1.TokenType.Identifier) && this.checkNext(token_type_1.TokenType.Period)) {
            return this.path();
        }
        if (this.check(token_type_1.TokenType.Identifier)) {
            return new expression_1.Identifier(this.advance());
        }
        if (this.check(token_type_1.TokenType.Null)) {
            return new expression_1.Null(this.advance());
        }
        throw new ParseError('Expect expression', token_type_1.TokenType.Unknown, this.peek());
    }
    function() {
        const name = this.consume(token_type_1.TokenType.Identifier, 'Expect function name');
        this.consumeWhitespace();
        this.consume(token_type_1.TokenType.LeftParen, 'Expect "(" after function name');
        const parameters = [];
        if (!this.check(token_type_1.TokenType.RightParen)) {
            do {
                const param = this.expression();
                parameters.push(param);
            } while (this.match(token_type_1.TokenType.Comma));
        }
        this.consumeWhitespace();
        this.consume(token_type_1.TokenType.RightParen, 'Expect ")" after parameters');
        return new expression_1.Function(name, parameters);
    }
    path() {
        const object = this.consume(token_type_1.TokenType.Identifier, 'Expect identifier');
        this.consume(token_type_1.TokenType.Period, 'Expect "." after identifier name');
        if (this.check(token_type_1.TokenType.Identifier)) {
            const property = this.checkNext(token_type_1.TokenType.Period) ? this.path() : new expression_1.Identifier(this.advance());
            return new expression_1.Path(object, property);
        }
        throw new ParseError('Expect identifier', token_type_1.TokenType.Unknown, this.peek());
    }
    stringLiteral() {
        const token = this.consume(token_type_1.TokenType.String, 'Expect string literal');
        if (token.lexeme.startsWith(`"`)) {
            return new expression_1.Literal(token.literal.replace(/\\"/g, '"'), token);
        }
        if (token.lexeme.startsWith(`'`)) {
            return new expression_1.Literal(token.literal.replace(/\\'/g, `'`), token);
        }
        return new expression_1.Literal(token.literal, token);
    }
    consume(type, message) {
        if (this.check(type)) {
            return this.advance();
        }
        throw new ParseError(message, type, this.peek());
    }
    match(...types) {
        for (const type of types) {
            if (this.check(type)) {
                this.advance();
                return true;
            }
        }
        return false;
    }
    check(type) {
        if (this.isAtEnd()) {
            return false;
        }
        return this.peek().type === type;
    }
    checkNext(...type) {
        if (this.isAtEnd()) {
            return false;
        }
        return type.includes(this.peekNext().type);
    }
    consumeWhitespace() {
        while (this.check(token_type_1.TokenType.Whitespace)) {
            this.advance();
        }
    }
    advance() {
        if (!this.isAtEnd()) {
            this.current += 1;
        }
        return this.previous();
    }
    isAtEnd() {
        return this.peek().type === token_type_1.TokenType.EOF;
    }
    peek() {
        return this.tokens[this.current];
    }
    peekNext() {
        let index = this.current + 1;
        while (this.tokens[index].type === token_type_1.TokenType.Whitespace) {
            index += 1;
        }
        return this.tokens[index];
    }
    previous() {
        return this.tokens[this.current - 1];
    }
}
exports.Parser = Parser;
//# sourceMappingURL=parser.js.map